<template>
  <div class="page">
    <klfs-header tab="product"></klfs-header>

    <div class="page-wrapper">

      <div class="section-block index-bg-img">
        <img class="image" src="../../assets/product/banner.png" alt="">
      </div>

      <div class="section-block">
        <div class="section-block-wrap">
          <h1 class="section-title">人气爆品</h1>
          <div class="section-swiper-wrap">
            <div class="swiper-container swiper-hot" ref="swiperHot">
              <div class="swiper-wrapper">
                <div class="swiper-slide" v-for="(item) in hotBanner" :key="item.id">
                  <img class="swiper-img" :src="item.imgUrl" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="section-block section-block-cate">
        <div class="section-block-wrap">
          <h1 class="section-title">产品分类</h1>
          <div class="section-cate-wrap">
            <div class="cate-tabs-list flex">
              <div class="cate-tab" :class="cateIndex == index? 'current' : ''" v-for="(item, index) in cateList" :key="item.id" @mouseenter="tabHover($event, index)">
                <img :src="item.imgUrl" alt="">
                <span class="cate-tab-title">{{ item.title }}</span>
              </div>
            </div>
            <div class="cate-tabs-content">
              <div class="cate-product-list flex flex-align-bottom" v-for="(item, index) in cateList" :key="item.id" v-show="cateIndex == index">
                <div class="cate-product-item" v-for="(subItem, subIndex) in item.list" :key="subIndex">
                  <img :src="subItem.imgUrl" alt="">
                  <p>{{ subItem.name }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="section-block">
        <div class="section-block-wrap">
          <h1 class="section-title">品质溯源</h1>
          <div class="section-swiper-wrap">
            <div class="swiper-container swiper-origin" ref="swiperOrigin">
              <div class="swiper-wrapper">
                <div class="swiper-slide" v-for="(item) in originBanner" :key="item.id">
                  <img class="swiper-img" :src="item.imgUrl" />
                  <div class="text-block">
                    <div class="text-block-title">{{ item.title }}</div>
                    <div class="text-block-content">{{ item.text }}</div>
                  </div>
                </div>
              </div>
              <div class="swiper-origin-arrow swiper-origin-next">
                <img src="../../assets/product/arrow-right.png" alt="">
              </div>
              <div class="swiper-origin-arrow swiper-origin-prev">
                <img src="../../assets/product/arrow-left.png" alt="">
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

    <klfs-footer></klfs-footer>
  </div>
</template>

<script>

import Swiper from 'swiper'
import KlfsHeader from "@/components/KlfsHeader.vue";
import KlfsFooter from "@/components/KlfsFooter.vue";
export default {
  name: 'ProductPage',
  components: {
    KlfsHeader,
    KlfsFooter,
  },
  data() {
    return {
      hotBanner: [
        {id: 0, imgUrl: require('@/assets/product/hot1.png')},
        {id: 1, imgUrl: require('@/assets/product/hot2.png')},
        {id: 2, imgUrl: require('@/assets/product/hot3.png')},
      ],
      hotSwiper: null,
      originBanner: [
        {id: 0, imgUrl: require('@/assets/product/history1.png'), title: '完整供应链体系，保障原料供应', text: '拥有完整的“研发-采购-生产-仓储-物流-运营管理”供应链体系，成本控制是核心优势。\n 自建仓储物流，保障原材料供应，为加盟商提供高效率、低成本运输配送服务。'},
        {id: 1, imgUrl: require('@/assets/product/history2.png'), title: '16年茶饮研发经验', text: '拥有专业研发团队，坚持自主创新，数十年来致力于产品研发及配方研究，不断升级产品、\n 研发新品，保证月月上新，保持消费者的产品新鲜感。'},
        {id: 2, imgUrl: require('@/assets/product/history3.png'), title: '完备培养体系，提供专业运营支持', text: '拥有教学面积达1000多平米的创新教研中心，专业、强大的师资团队，完备的培训体系，\n 先进的信息平台，为加盟伙伴餐品实操、自主经营和区域代理提供高度定制、全面的支持方案。'},
        {id: 3, imgUrl: require('@/assets/product/history4.png'), title: '自有农产品基地，新鲜直采', text: '拥有番薯、茶叶及柠檬等上游原材料生产基地，当季优选直采，保证原材料新鲜 \n 和品质稳定，同时降低供应链成本压力。'},
        {id: 4, imgUrl: require('@/assets/product/history5.png'), title: '茶饮+小吃，双线营收', text: '以“茶饮+小吃”双品类模式，打造高性价比的超级爆品，带动连带消费，\n 创造1+1>2的营收价值。'},
        {id: 5, imgUrl: require('@/assets/product/history6.png'), title: '核心原料自产，保证品质和价格稳定', text: '自建原料工厂，核心原料自主自动化生产，坚持以严格的生产管理、标准化的生产流程，\n 保证原料价格及品质稳定，保证门店的利润。'},
      ],
      originSwiper: null,
      cateList: [
        {
          id: '1',
          title: '首创超长杯',
          imgUrl: require('@/assets/product/tab1.png'),
          list: [
            { name: '超长杯冰鲜柠檬水', imgUrl: require('@/assets/product/ccb1.png') },
            { name: '超长杯鸭屎香柠檬茶', imgUrl: require('@/assets/product/ccb2.png') },
            { name: '超长杯泰红柠檬茶', imgUrl: require('@/assets/product/ccb3.png') },
            { name: '超长杯三拼奶茶', imgUrl: require('@/assets/product/ccb4.png') },
          ]
        },
        {
          id: '2',
          title: '超清爽果茶',
          imgUrl: require('@/assets/product/tab2.png'),
          list: [
            { name: '百香果双响炮', imgUrl: require('@/assets/product/cqs1.png') },
            { name: '杨枝甘露', imgUrl: require('@/assets/product/cqs2.png') },
            { name: '多肉玫珑蜜瓜', imgUrl: require('@/assets/product/cqs3.png') },
            { name: '霸王桶香柠粉芭乐', imgUrl: require('@/assets/product/cqs4.png') },
          ]
        },
        {
          id: '3',
          title: '超人气奶茶',
          imgUrl: require('@/assets/product/tab3.png'),
          list: [
            { name: '招牌薯圆奶茶', imgUrl: require('@/assets/product/zp1.png') },
            { name: '烧仙草奶茶', imgUrl: require('@/assets/product/zp2.png') },
            { name: '草莓布蕾奶冻', imgUrl: require('@/assets/product/zp3.png') },
            { name: '超多料奶茶吨吨桶', imgUrl: require('@/assets/product/zp4.png') },
          ]
        },
        {
          id: '4',
          title: '特色小食',
          imgUrl: require('@/assets/product/tab4.png'),
          list: [
            { name: '番薯肉肠', imgUrl: require('@/assets/product/xc1.png') },
            { name: '酸奶双皮奶', imgUrl: require('@/assets/product/xc2.png') },
            { name: '烤番薯', imgUrl: require('@/assets/product/xc3.png') },
            { name: '紫薯手抓饼', imgUrl: require('@/assets/product/xc4.png') },
          ]
        }
      ],
      cateIndex: 0
    }
  },
  created() {

  },
  mounted() {
    this.initHotSwiper()
    this.initOriginSwiper()
  },
  methods: {
    tabHover(e, index) {
      this.cateIndex = index
    },
    initHotSwiper() {
      // 人气爆品
      this.hotSwiper = new Swiper('.swiper-hot', {
        autoplay: {
          delay: 3000,//1秒切换一次
        },
        // speed: 300,
        slidesPerView: 3,
        spaceBetween: 0,
        centeredSlides: true,
        loop: true,
        slideToClickedSlide: true, // 点击幻灯片时自动跳转
        // zoom: true,
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
        on: {
          init: () => {
            console.log('init detailSwiper')
          },
        }
      });
    },
    initOriginSwiper() {
      // 品质溯源
      this.originSwiper = new Swiper('.swiper-origin', {
        autoplay: {
          delay: 3000,//1秒切换一次
        },
        loop: false,
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
        navigation: {
          nextEl: '.swiper-origin-next',
          prevEl: '.swiper-origin-prev',
        },
        on: {
          init: () => {
            console.log('init detailSwiper')
          },
        }
      });
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.section-block-wrap {
  max-width: 1420px;
  padding: 0 20px 100px;
  margin: 0 auto;
  position: relative;
}
.section-title {
  font-size: 50px;
  color: var(--p);
  text-align: center;
  padding: 50px 0;
}

.swiper-hot {
  padding: 54px 0;
}
.swiper-img {
  display: block;
  width: 100%;
  margin: 0 auto;
  mix-blend-mode: multiply;
}
::v-deep .swiper-hot .swiper-slide {
  transform: scale(1);
  transition: all .5s ease;
}
::v-deep .swiper-hot .swiper-slide-active {
  transform: scale(1.4);
  z-index: 1;
}

.section-block-cate {
  background-color: #f8f8f8;
}
.section-block-cate .section-block-wrap {
  padding-bottom: 160px;
}
.cate-tabs-list {
  margin: 0 -15px 60px;
}
.cate-tab {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  margin: 0 15px;
  cursor: pointer;
}
.cate-tab-title {
  width: 154px;
  height: 45px;
  line-height: 42px;
  font-size: 22px;
  font-weight: bold;
  text-align: center;
  color: #fff;
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: 45px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  transition: all .5s;
}
.cate-tab.current .cate-tab-title {
  background-color: var(--p);
}

.cate-tabs-content {
  position: relative;
}
.cate-product-list {
  position: relative;
  z-index: 1;
}
.cate-tabs-content:after {
  content: ' ';
  display: block;
  height: 170px;
  position: absolute;
  left: 0;
  right: 0;
  bottom: -56px;
  z-index: 0;
  background-color: #fff;
  border-radius: 14px;
}
.cate-product-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 25%;
}
.cate-product-item img {
  display: block;
}
.cate-product-item p {
  font-size: 22px;
  color: var(--p);
  margin-top: 20px;
}

.swiper-origin {
  border-radius: 300px;
}
.swiper-origin-arrow {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 2;
  cursor: pointer;
}
.swiper-origin-next {
  right: 60px;
}
.swiper-origin-prev {
  left: 60px;
}
.text-block {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  color: #fff;
  background: linear-gradient(to bottom, rgba(255, 255, 255, 0.05), var(--o));
  padding: 20px 250px 10px;
}
.text-block-title {
  font-weight: bold;
  font-size: 16px;
  margin-bottom: 10px;
}

@media screen and (max-width: 1200px) {
  .text-block {
    padding: 20px 200px 10px;
  }
}

@media screen and (max-width: 768px) {
  .text-block-title {
    font-size: 14px;
  }
  .section-title {
    font-size: 22px;
    padding: 20px 0;
  }
  .section-block-wrap {
    padding: 0 15px 40px;
  }
  ::v-deep .swiper-hot .swiper-slide {
    transform: scale(1.6);
  }
  ::v-deep .swiper-hot .swiper-slide-active {
    transform: scale(2.4);
    z-index: 1;
  }
  ::v-deep .swiper-hot .swiper-slide-prev,
  ::v-deep .swiper-hot .swiper-slide-next {
    opacity: 0.8;
  }

  .section-block-cate .section-block-wrap {
    padding-bottom: 40px;
  }
  .cate-tabs-list {
    width: 100%;
    margin: 0 0 30px;
  }
  .cate-tab {
    width: 25%;
    margin: 0 5px;
  }
  .cate-tab img {
    display: block;
    width: 100%;
  }
  .cate-tab-title {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    line-height: unset;
    font-size: 14px;
    border-radius: 4px;
  }
  .cate-product-list {
    flex-wrap: wrap;
  }
  .cate-product-item {
    width: 50%;
    padding: 0 15px;
    margin-bottom: 20px;
  }
  .cate-product-item img {
    display: block;
    width: 100%;
  }
  .cate-product-item p {
    font-size: 14px;
  }
  .cate-tabs-content:after {
    display: none;
  }
  .swiper-origin-arrow img {
    width: 24px;
    height: 24px;
  }
  .swiper-origin-prev {
    left: 15px;
  }
  .swiper-origin-next {
    right: 15px;
  }
  .text-block {
    padding: 20px 60px 0;
  }
  .text-block-content {
    display: none;
  }
}
</style>
